import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const UsageScenariosC = () => {
    const { t } = useLang('Delta3MaxSeriesStation.UsageScenariosC');
    return (
        <section className={`${styles.UsageScenariosC} GtmModuleData-section`} id="UsageScenariosC" data-section-id={'UsageScenariosC'}>
            <EcoImg
                isOpenLazy
                pc="https://websiteoss.ecoflow.com/upload/image/1762224178834/top%20center.jpg"
                pad="https://websiteoss.ecoflow.com/figma-uploads/1760962438791-g2m5wk-compressed-Frame%202094654313.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1760962438791-g2m5wk-compressed-Frame%202094654313.jpg"
                alt={t('title')}
            />
            <div className="sub-text">
                <p className="title">{t('title')}</p>
                <p className="sub-title">{t('subTitle')}</p>
            </div>
        </section>
    );
};

export default UsageScenariosC;
